<template>
  <div>
    <span v-for="(item , index ) in licenseList" :key="index">{{item}}</span>
  </div>
</template>

<script>
export default {
  data: () => ({
    licenseList: [" ", " ", " ", " ", " ", " ", " "]
  }),
  props: {
    license: {
      type: String
    }
  },
  watch: {
    license(newV, oldV) {
      if (newV != oldV) {
        if (this.license) {
          this.licenseList = this.license.split("");
        }
      }
    }
  },
  mounted() {
    if (this.license) {
      this.licenseList = this.license.split("");
    }
  }
};
</script>

<style lang="less" scoped >
div {
  display: flex;

  > span {
    display: block;
    width: 20px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    border: 1px solid #ccc;
    margin-right: 4px;
  }
}
</style>
